<template>
  <v-container fluid class="pa-0">
    <template v-if="scope === 'herdtrax'">
      <v-expansion-panels tile dark v-model="panel">
        
        <!-- Herdtrax Optional Filters -->
        <v-expansion-panel v-if="scope === 'herdtrax'" :disabled="!filtersExist">
          <v-expansion-panel-header :color="settings.colourCode">Optional Filters</v-expansion-panel-header>
          <v-expansion-panel-content :color="settings.colourCode + ' lighten-4'">
            <user-filter-list v-bind:optionalFilters="optionalFilters" />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Herdtrax Traits -->
        <v-expansion-panel class="white">
          <v-expansion-panel-header :color="settings.colourCode">Prioritized Traits</v-expansion-panel-header>
          <v-expansion-panel-content>
            <user-trait-list
              v-bind:settings="settings"
              v-bind:traitsContainer="traitsContainer"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <!-- Bull Finder Traits -->
    <template v-else>
      <user-trait-list
        v-bind:settings="settings"
        v-bind:traitsContainer="traitsContainer"
      />
    </template>
  </v-container>
</template>

<script>
import UserFilterList from '@/components/UserFilterList'
import UserTraitList from '@/components/UserTraitList'
import { AppColor, InputTypeId } from '@/config.js'

export default {
  name: 'UserQueryDef',
  components: {
    UserFilterList,
    UserTraitList
  },
  props: {
    scope: {
      type: String,
      default: 'herdtrax'
    },
    traitsContainer: {
      type: Object,
      default: null
    },
    optionalFilters: {
      type: Array,
      default: null
    },
    settings: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      appColor_Light: AppColor.Light,
      appColor_PanelBackgroundLight: AppColor.PanelBackgroundLight,
      appColor_ContentToolbarLight: AppColor.ContentToolbarLight,
      appColor_Selected: AppColor.Selected,

      // input type ids
      inputTypeId_Dropdown: InputTypeId.Dropdown,
      inputTypeId_RangeSlider: InputTypeId.RangeSlider,
      inputTypeId_MultiSelect: InputTypeId.MultiSelect,

      panel: this.filtersExist || this.scope === 'bullfinder' ? 0 : 1
    }
  },
  computed: {
    filtersExist () {
      if (this.optionalFilters === null) return false
      return this.optionalFilters.length > 0
    }
  }
}
</script>

